// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1735":"95c9e2d595292751","1869":"6642119ba25839d9"}[chunkId] + ".css";
};